import React from "react";
import axios from "axios";
import { Upload } from "lucide-react";
import { useToast } from "../../Admissionform/ToastManager";

const OfferLetterActions = ({ studentData, onStudentDataUpdate }) => {
  const { showSuccess, showError } = useToast();

  const placementStatus =
    studentData?.placementStatus || studentData?.placementstatus;

  const isPlaced =
    placementStatus === "Placed" ||
    placementStatus === "Placed but not accepted the Offer";


  // 📤 Upload Offer Letter (ANY FILE)
  const handleOfferLetterUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("offerLetter", file);
    formData.append("studentId", studentData.studentId);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/upload/offer-letter`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.success) {
        showSuccess("Offer letter uploaded successfully!");
        onStudentDataUpdate?.({
          ...studentData,
          offerLetterPath: res.data.filePath
        });
      } else {
        throw new Error(res.data.message);
      }
    } catch (error) {
      console.error("Offer letter upload error:", error);
      showError(error.response?.data?.message || "Failed to upload offer letter");
    } finally {
      event.target.value = "";
    }
  };

  // 📥 Download Offer Letter
  const handleOfferLetterDownload = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/download/offer-letter/${studentData.studentId}`,
        { responseType: "blob" }
      );
      
      const contentDisposition = response.headers["content-disposition"];
      let filename = `OfferLetter_${studentData.studentName}`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="([^"]+)"/);

        if (match && match[1]) {
          filename = match[1].trim();
        }
      }


      const blob = new Blob([response.data], {
        type: response.headers["content-type"]
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showSuccess("Offer letter downloaded successfully!");
    } catch (error) {
      console.error("Offer letter download error:", error);
      showError("Failed to download offer letter");
    }
  };

  return (
    <>
      {/* 🔒 Upload only if Placed */}
      {isPlaced && (
        <>
          <input
            id="offer-letter-upload"
            type="file"
            onChange={handleOfferLetterUpload}
            style={{ display: "none" }}
          />

          <label className="sidebar-btn" htmlFor="offer-letter-upload">
            <Upload size={16} /> Upload Offer Letter
          </label>
        </>
      )}

      {/* 📥 Download allowed if file exists */}
      {studentData?.offerLetterPath && (
        <button
          className="sidebar-btn"
          onClick={handleOfferLetterDownload}
        >
          📄 Download Offer Letter
        </button>
      )}
    </>
  );
};

export default OfferLetterActions;